
export enum ProjectViewType {
	Grid = "grid",
	Map = "map",
	Timeline = "timeline"
}
